import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Loader from "./Loader";
import BestPerformingSchoolList from "./BestPerformingSchoolList";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";
import Select from "react-select";
import SchoolVideoProgress from "./SchoolVideoProgress";
import "../Assets/Css/SchoolDashboard.css";
import { SCHOOL_LIST_GET_API } from "./AllApi";
import BestPerformingTeachers from "./BestPerformingTeachers";
import { Link, useLocation } from "react-router-dom";

const SchoolDashboard = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isGradeLoading, setIsGradeLoading] = useState(false);
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const  principalName  = location.state?.principalName || "";
  const referrer = location.state?.referrer || "/school-dashboard";
  // console.log("states: ",location.state)

  // Fetch schools from the API
  useEffect(() => {
    const fetchSchools = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(SCHOOL_LIST_GET_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
            "Content-Type": "application/json",
          },
        }); // Replace with your API endpoint
        const data = await response.json();
        const formattedSchools = data.allSchools.map((school) => ({
          value: school.school_id, // Use unique identifiers as values
          label: school.school_name,
          schoolDetails: school,
        }));
        // console.log("Data: ",data.allSchools)
        setSchools(formattedSchools);

        // setSelectedSchool(formattedSchools[0]);
        const stateSchoolId = location.state?.school_id;
        if (stateSchoolId) {
          const preselectedSchool = formattedSchools.find(
            (school) => school.value === stateSchoolId
          );
          setSelectedSchool(preselectedSchool || formattedSchools[0]);
        } else {
          setSelectedSchool(formattedSchools[0]); // Default to the first school
        }
      } catch (error) {
        console.error("Error fetching school data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchools();
  }, [location.state, token]);

  useEffect(() => {
    // Store referrer in localStorage for Sidebar
    localStorage.setItem("referrer", referrer);

    // Clear referrer on unmount
    return () => {
      localStorage.removeItem("referrer");
    };
  }, [referrer]);

  // Handle school selection
  const handleSchoolChange = (selectedOption) => {
    setIsGradeLoading(true);
    setSelectedSchool(selectedOption);
    // Trigger API calls or data updates based on the selected school
    // console.log('Selected School:', selectedOption);
    setTimeout(() => {
      // console.log('Selected School:', selectedOption);
      setIsGradeLoading(false); // Stop loader
    }, 2000);
  };

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            {location.state?.school_id && selectedSchool ? (
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <Link to="/principal" className="prevPage">
                    {principalName ? principalName : null}
                  </Link>
                  {principalName && (
                    <img
                      src={nextArrow}
                      alt="Next"
                      height={40}
                      className="mt-1"
                    />
                  )}
                  <p className="currentPage">School Dashboard</p>
                </ol>
              </nav>
            ) : (
              <p className="admin_title">School Dashboard</p>
            )}
            <div className="mt-3 mb-4">
              <label htmlFor="school-select" className="form-label">
                Select School:
              </label>
              <div style={{ width: "50%" }}>
                <Select
                  id="school-select"
                  options={schools}
                  value={selectedSchool}
                  onChange={handleSchoolChange}
                  isClearable={isClearable}
                  isSearchable={isSearchable}
                  placeholder="-- Select School --"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      boxShadow: "0px 4px 34px 0px #b6c1c757",
                      borderRadius: "8px",
                      border: "none",
                    }),
                  }}
                />
              </div>
            </div>

            {isGradeLoading || !selectedSchool ? (
              <Loader /> // Show loader when changing the grade
            ) : (
              <>
                <SchoolVideoProgress
                  school_id={selectedSchool?.value}
                  schoolDetails={selectedSchool?.schoolDetails}
                  principalName={principalName?principalName:""}
                  referrer={referrer}
                />
                <BestPerformingTeachers
                  school_id={selectedSchool?.value}
                  schoolDetails={selectedSchool?.schoolDetails}
                  principalName={principalName?principalName:""}
                  referrer={referrer}
                  // referrer={location.state?.referrer ||"/school-dashboard"}
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SchoolDashboard;
